export class TLCEventHandler {
  /**
   *
   * @type {number}
   */
  guid = null;

  /**
   *
   * @type {function(TLCEvent)}
   */
  callback = null;

  /**
   *
   * @type {boolean}
   */
  isOneTime = null;

  /**
   *
   * @type {*}
   */
  scope = null;

  /**
   * @constructor
   * @param {Object} obj
   */
  constructor(obj) {
    this.guid = obj.guid;
    this.callback = obj.callback;
    this.isOneTime = obj.isOneTime;
    this.scope = obj.scope;
  }
}
